
namespace GeniuzPOS.Common {
    @Serenity.Decorators.registerClass('GeniuzPOS.Common.ImportItemMasterDialog')
    export class ImportItemMasterDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return "Common.ImportForm"; }
        protected getService() { return Common.CsiService.baseUrl; }

        protected form = new Common.ImportForm(this.idPrefix);

        public importState: () => void

        constructor() {
            super();

            this.dialogTitle = "Import From Excel";

            const dateDiv = document.querySelector(`.Date`)
            let label = dateDiv.querySelector('label')
            let title = label.getAttribute('title')
            label.innerHTML = `<sup title="this field is required">*</sup>${title}`

            const fileDiv = document.querySelector(`.FileName`)
            label = fileDiv.querySelector('label')
            title = label.getAttribute('title')
            label.innerHTML = `<sup title="this field is required">*</sup>${title}`

        }

        protected okClickValidated() {
            if (!this.form.Date.value || !this.form.FileName.value) {
                return
            }
            if (!this.form.FileName.value.Filename.includes(`.xls`)) {
                return
            }
            super.okClickValidated();
        }

        protected onDialogClose() {
            super.onDialogClose();

            const date = this.form.Date.value
            const file = this.form.FileName.value
            if (!date || !file) {
                return
            }
            // Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
            Common.CsiService.ImportItemMasterTemplate
                ({
                    Date: date,
                    FileName: file.Filename,
                    OriginalName: file.OriginalName,
                    Username: Authorization.userDefinition.Username
                }, (response) => {
                    this.importState()
                })
        }

        protected getDialogOptions() {
            const opt = super.getDialogOptions();
            opt.width = 650;
            opt.modal = true;
            return opt;
        }
    }
}